var _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83325 7.83334H2.33325V13.6667H4.83325V7.83334Z",
    fill: "#6E7177"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 7.83334H7.75V13.6667H10.25V7.83334Z",
    fill: "#6E7177"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 15.3333H0.666626V17.8333H17.3333V15.3333Z",
    fill: "#6E7177"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 7.83334H13.1666V13.6667H15.6666V7.83334Z",
    fill: "#6E7177"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 0.333336L0.666626 4.5V6.16667H17.3333V4.5L8.99996 0.333336Z",
    fill: "#6E7177"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e14d1cf319c649c3520289b5ba11161b.svg";
export { ForwardRef as ReactComponent };